/* 
  This is the service responsible for saving all the measured values to the 'database' (a json file) at: `${PATH}/${this.#fermentationId}/values.json`
  We start logging on the fermentationstart event
  We stop logging on the fermentationstop event
*/

import { Plugin }		from "plugin";
import * as fs			from "fs";
import sleep 			from "sleep";
import { TextEncoder }	from "encoding";

const PATH = "/var/lib/biocore/server/fermentations";

class LogData {
  constructor(...args) {
    this.__entries = [];
  }
  append(name, value) {
    this.__entries.push([name, value]);
  }
  *entries() {
    for (const entry of this.__entries) {        
      yield [ entry[0], entry[1] ];
    }
  }
}


class JSONLogService extends Plugin {
  constructor(...args) {
    super(...args);

    this.addEventListener("fermentationstart", this.#fermentationstart_handler.bind(this));
    this.addEventListener("fermentationstop", this.#fermentationstop_handler.bind(this));    
  }
  #fermentationId = null
  #update_handler_f = null
  /* when a farmentation starts we will send progress riport in requested intervals */
  #fermentationstart_handler(event) {    
    var fermentation = event.detail;
    this.#fermentationId = fermentation.id;
    this.#update_handler_f = this.#update_handler.bind(this);
    this.addEventListener("update", this.#update_handler_f);
  }
  /* when the fermentation stops we stop sending progress riport */
  #fermentationstop_handler() {    
    this.removeEventListener("update", this.#update_handler_f);
    this.#fermentationId = null;
    this.#update_handler_f = null;
  }  
  async #update_handler(event) {    

    /*TODO: device logging update */
    
    var logData = new LogData();
    
    jfermi.dispatchEvent( new CustomEvent("logdata", {
      detail: {
        logData: logData
      }
    }) );
    
    for (var device in this.devices) {
      if (typeof this.devices[device].logData == "function") {
        try {
          this.devices[device].logData(logData);         
        } catch(e) {
          console.error(`Failed to create log for device ${device.name}`);
        }
      }
    }    
    await sleep(0);
    //console.log(JSON.stringify(logData.entries().next()));
    
    let o={};
    o.dt = new Date();

    for (const [key, value] of logData.entries()) {
      //console.log(`${key} -> ${value}`);
      o[key] = value;
      //console.log(JSON.stringify(entry));
      
    }
    
    const ndjson = `${JSON.stringify(o)}\n`;
    const arrayBuffer = new TextEncoder().encode(ndjson).buffer;
    
    fs.writeFileSync(`${PATH}/${this.#fermentationId}/values.json`, arrayBuffer, {
      flags: fs.O_WRONLY | fs.O_APPEND
    });

  }      
}


export default JSONLogService;